// @ts-ignore
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { CustomerRegistrationResponseFragmentDoc } from '../../../graphql/api/auth/fragments/customerRegistrationResponse.generated';
export const EnquiryResponseNewCustomerFragmentDoc = gql`
    fragment enquiryResponseNewCustomer on EnquiryResponseNewCustomer {
  __typename
  customer {
    ...customerRegistrationResponse
  }
}
    ${CustomerRegistrationResponseFragmentDoc}`;